import { useParams, useLocation } from 'react-router-dom';
import TrackerEditContainer from './TrackerEditContainer';
import { Ingredient } from '../types';

const TrackerEditPage = () => {
  const { dietMealId } = useParams();
  const {
    ingredients: initialIngredients,
    timestamp,
    mealName,
  } = useLocation().state as {
    ingredients: Ingredient[];
    timestamp: number;
    mealName: string;
  };
  return (
    <TrackerEditContainer
      key={dietMealId}
      initialIngredients={initialIngredients}
      timestamp={timestamp}
      mealName={mealName}
      mode="forward-navigation" // for describe meal
    />
  );
};

export default TrackerEditPage;
